import { createSlice } from '@reduxjs/toolkit';

import { EMPTY_VALUES } from 'constants/general';

const initialState = {
	documentsToReview: null,
	myDocuments: null,
	waves: EMPTY_VALUES.ARRAY,
	regions: EMPTY_VALUES.ARRAY,
	superiors: EMPTY_VALUES.ARRAY,
	clientsMyDocuments: EMPTY_VALUES.ARRAY,
	clientsDocumentsToReview: EMPTY_VALUES.ARRAY,
	userIsSuperior: false,
	userIsSuperiorAndSubordinate: false,
	myDocumentsTotalRows: 0,
	showMyDocuments: false,
};

export const productionControl = createSlice({
	name: 'productionControl',
	initialState,
	reducers: {
		setDocumentsToReview: (state, { payload }) => ({
			...state,
			documentsToReview: payload,
		}),
		appendDocumentsToReview: (state, { payload }) => ({
			...state,
			documentsToReview: [...state.documentsToReview, ...payload],
		}),
		resetDocumentsToReview: (state) => ({ ...state, documentsToReview: initialState.documentsToReview }),
		setMyDocuments: (state, { payload }) => ({
			...state,
			myDocuments: payload,
		}),
		appendMyDocuments: (state, { payload }) => ({
			...state,
			myDocuments: [...state.myDocuments, ...payload],
		}),
		resetMyDocuments: (state) => ({ ...state, myDocuments: initialState.MyDocuments }),
		setRegions: (state, { payload }) => ({
			...state,
			regions: payload,
		}),
		resetRegions: (state) => ({ ...state, regions: initialState.regions }),
		setSuperiors: (state, { payload }) => ({
			...state,
			superiors: payload,
		}),
		resetSuperiors: (state) => ({ ...state, superiors: initialState.superiors }),
		setSubordinates: (state, { payload }) => ({
			...state,
			subordinates: payload,
		}),
		resetSubordinates: (state) => ({ ...state, subordinates: initialState.subordinates }),
		setClientsDocumentsToReview: (state, { payload }) => ({
			...state,
			clientsDocumentsToReview: payload,
		}),
		resetClientsDocumentsToReview: (state) => ({
			...state,
			clientsDocumentsToReview: initialState.clientsDocumentsToReview,
		}),
		setClientsMyDocuments: (state, { payload }) => ({
			...state,
			clientsMyDocuments: payload,
		}),
		resetClientsMyDocuments: (state) => ({ ...state, clientsMyDocuments: initialState.clientsMyDocuments }),
		setUserIsSuperior: (state, { payload }) => ({
			...state,
			userIsSuperior: payload,
		}),
		setUserIsSuperiorAndSubordinate: (state, { payload }) => ({
			...state,
			userIsSuperiorAndSubordinate: payload,
		}),
		setMyDocumentsTotalRows: (state, { payload }) => ({
			...state,
			myDocumentsTotalRows: payload,
		}),
		setWavesCodelist: (state, { payload }) => ({
			...state,
			waves: payload,
		}),
		setShowMyDocuments: (state, { payload }) => ({
			...state,
			showMyDocuments: payload,
		}),
	},
});

export default productionControl.reducer;
export const REDUCER_NAME = productionControl.name;

export const {
	setDocumentsToReview,
	appendDocumentsToReview,
	resetDocumentsToReview,
	setMyDocuments,
	appendMyDocuments,
	resetMyDocuments,
	setRegions,
	resetRegions,
	setSuperiors,
	resetSuperiors,
	setSubordinates,
	resetSubordinates,
	setClientsDocumentsToReview,
	resetClientsDocumentsToReview,
	setClientsMyDocuments,
	resetClientsMyDocuments,
	setUserIsSuperior,
	setUserIsSuperiorAndSubordinate,
	setMyDocumentsTotalRows,
	setWavesCodelist,
	setShowMyDocuments,
} = productionControl.actions;
